import { faPersonCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react'
import SearchComponent from '../../../../../components/search/SearchComponent'
import Authentication from '../../../../../libs/api/services/Authentication'
import User from '../../../../../libs/api/services/User'
import CommonFunctionsContext from '../../../../common/CommonFunctionsProvider'
import PatientProfileManagement from '../../../patient/management/PatientProfileManagement'
import { PatientProvider } from '../../../patient/management/PatientProvider'
import CalendarContext from '../CalendarProvider'


export default function CalendarUserComponent({ type, onSelected, defaultValue, disabled }) {
  const { filters, patient, setPatient } = useContext(CalendarContext)
  const { createModal } = useContext(CommonFunctionsContext)
  const editMode = useRef(disabled)
  const _handleFindDefault = () => {
    if (type === 'patient' && Authentication.getFacilityRoles().filter(x => x !== "Patient" && x !== "Client").length === 0) {
      const profile = Authentication.UserProfile()
      onSelected({ id: parseInt(profile.id) })
      return { id: parseInt(profile.id), firstName: JSON.parse(profile.name).split(' ', 2)[0], lastName: JSON.parse(profile.name).split(' ', 2)[1] }
    }
    if (type === 'clinician' && Authentication.getFacilityRoles().filter(x => x === "Clinician").length > 0) {
      const profile = Authentication.UserProfile()
      onSelected({ id: parseInt(profile.id) })
      return { id: parseInt(profile.id), firstName: JSON.parse(profile.name).split(' ', 2)[0], lastName: JSON.parse(profile.name).split(' ', 2)[1] }
    }
    // if (!defaultValue) {
    //   if (type === 'clinician' && Authentication.getFacilityRole() === "Clinician") {
    //     return { id: parseInt(Authentication.UserId()) }
    //   }
    // }
  }
  const [users, setUsers] = useState([])
  const [user, setUser] = useState(defaultValue ? defaultValue : _handleFindDefault())

  useEffect(() => { if (user) onSelected(user) }, [user])

  useEffect(() => { _loadUsers() }, [])

  const _handleNewPatient = async (p) => {
    setPatient(p);
    await _loadUsers()
    setUser(p.userProfile)
  }


  const _loadUsers = async () => {
    User
      .GetAccessableUsersByType(type)
      .then(async (r) => {
        setUsers(r)
        const _patient = await patient
        if (type === 'patient' && _patient) {
          if (parseInt(Authentication.UserId()) !== parseInt(_patient)) {
            setUser(r.find(d => d.id === parseInt(_patient)))
            editMode.current = true
          }

        } else if (type === 'clinician') {
          if (!defaultValue) {
            if (type === 'clinician' && Authentication.getFacilityRole() === "Clinician") {
              setUser(r.find(d => d.id === parseInt(Authentication.UserId())))
              editMode.current = true
            }
          }

        }
      })
  }

  // if (user && (type === 'clinician' || type === 'patient') && editMode.current)
  //   return <div>{user.firstName} {user.lastName}</div>
  // var test = true
  // if (test)
  //   return JSON.stringify(Authentication.getFacilityRoles().filter(x => x !== "Patient" && x !== "Client"))
  if (type === 'patient' && Authentication.getFacilityRoles().filter(x => x !== "Patient" && x !== "Client").length === 0)
    // return JSON.stringify(user)
    return <div>{user.firstName} {user.lastName}</div>

  return (
    <SearchComponent
      focusSearch={true}
      defaultValue={user}
      onSelected={setUser}
      details={{
        data: users,
        options: {
          returns: 'object',
          reRefKey: 'id',
          template: [{
            refKey: 'firstName',
            descr: '',
          }, {
            refKey: 'lastName',
            descr: '',
          }],
          onAdd: type === 'patient' ? {
            action: (t) => {
              createModal(
                <PatientProvider><PatientProfileManagement className='text-dark' onSaved={(p) => _handleNewPatient(p)} /></PatientProvider>,
                'New Patient Details',
                <FontAwesomeIcon icon={faPersonCirclePlus} size='2x' />
              )
            },
            text: 'New Patient'
          } : undefined
        }
      }} />
  )
}


export function CalendarFacilityCliniciansUserComponent({ type, onSelected, defaultValue, disabled, facility }) {
  const { filters, patient, setPatient } = useContext(CalendarContext)
  const { createModal } = useContext(CommonFunctionsContext)
  const editMode = useRef(disabled)
  const _handleFindDefault = () => {
    if (type === 'patient' && Authentication.getFacilityRoles().filter(x => x !== "Patient" && x !== "Client").length === 0) {
      const profile = Authentication.UserProfile()
      onSelected({ id: parseInt(profile.id) })
      return { id: parseInt(profile.id), firstName: JSON.parse(profile.name).split(' ', 2)[0], lastName: JSON.parse(profile.name).split(' ', 2)[1] }
    }
    if (type === 'clinician' && Authentication.getFacilityRoles().filter(x => x === "Clinician").length > 0) {
      const profile = Authentication.UserProfile()
      onSelected({ id: parseInt(profile.id) })
      return { id: parseInt(profile.id), firstName: JSON.parse(profile.name).split(' ', 2)[0], lastName: JSON.parse(profile.name).split(' ', 2)[1] }
    }
    // if (!defaultValue) {
    //   if (type === 'clinician' && Authentication.getFacilityRole() === "Clinician") {
    //     return { id: parseInt(Authentication.UserId()) }
    //   }
    // }
  }
  const [users, setUsers] = useState([])
  const [user, setUser] = useState(defaultValue ? defaultValue : _handleFindDefault())

  useEffect(() => { if (user) onSelected(user) }, [user])

  useEffect(() => { _loadUsers() }, [])

  const _handleNewPatient = async (p) => {
    setPatient(p);
    await _loadUsers()
    setUser(p.userProfile)
  }

  useEffect(() => {
    onSelected({ id: 0 })
    _loadUsers()
  }, [facility])


  const _loadUsers = async () => {
    if (!facility) return
    User
      .GetAccessableFacilityUsers(facility.id, type)
      .then(async (r) => {
        setUsers(r)
        const _patient = await patient
        if (type === 'patient' && _patient) {
          if (parseInt(Authentication.UserId()) !== parseInt(_patient)) {
            setUser(r.find(d => d.id === parseInt(_patient)))
            editMode.current = true
          }

        } else if (type === 'clinician') {
          if (!defaultValue) {
            if (type === 'clinician' && Authentication.getFacilityRole() === "Clinician"
              && r.find(u => u.id === parseInt(Authentication.UserId()))) {
              setUser(r.find(d => d.id === parseInt(Authentication.UserId())))
              editMode.current = true
            }
          } else {
            const inFacility = r.find(u => u.id === defaultValue.id)
            if (!inFacility)
              setUser()
          }
        }
      })
  }

  if (!facility) return <></>
  // if (user && (type === 'clinician' || type === 'patient') && editMode.current)
  //   return <div>{user.firstName} {user.lastName}</div>
  // var test = true
  // if (test)
  //   return JSON.stringify(Authentication.getFacilityRoles().filter(x => x !== "Patient" && x !== "Client"))
  if (type === 'patient' && Authentication.getFacilityRoles().filter(x => x !== "Patient" && x !== "Client").length === 0)
    // return JSON.stringify(user)
    return <div>{user.firstName} {user.lastName}</div>

  return (
    <SearchComponent
      focusSearch={true}
      defaultValue={user}
      onSelected={setUser}
      details={{
        data: users,
        options: {
          returns: 'object',
          reRefKey: 'id',
          template: [{
            refKey: 'firstName',
            descr: '',
          }, {
            refKey: 'lastName',
            descr: '',
          }],
          onAdd: type === 'patient' ? {
            action: (t) => {
              createModal(
                <PatientProvider><PatientProfileManagement className='text-dark' onSaved={(p) => _handleNewPatient(p)} /></PatientProvider>,
                'New Patient Details',
                <FontAwesomeIcon icon={faPersonCirclePlus} size='2x' />
              )
            },
            text: 'New Patient'
          } : undefined
        }
      }} />
  )
}
